module.exports = __webpack_public_path__ + "static/img/shezhi_huodong.e2645c3a.png";